import React, { useState, useEffect } from "react";
import SecondaryHeader from "olive-react-myoneui/lib/SecondaryHeader";
import SecondaryHeaderInfo from "olive-react-myoneui/lib/SecondaryHeaderInfo";
import HorizontalNavLinkList from "../../components/student-dashboard/HorizontalNavLinkList";
import { Container } from "olive-react-myoneui";
import CourseInnerBundle from "../../components/student-dashboard/courses/CourseInnerBundle";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";

function MyCourseInnerBundle() {

  return (
    <>
      <TopHeader />
      <NavigationBarStudentLanding />
      <div className="dashboard-wrapper w-100">
        <HorizontalNavLinkList />
        <SecondaryHeader>
          <SecondaryHeaderInfo SecondaryHeaderTitle="My Course" />
        </SecondaryHeader>
        <CourseInnerBundle />
      </div>
    </>
  );
}

export default MyCourseInnerBundle;
